import * as THREE from "three";

class StartLocation {
  static createStartLocation(url, callback) {
    // later use https://github.com/mrdoob/three.js/issues/1327 or a model
    new THREE.TextureLoader().load("asset/startlocation/spawnpoint_a.jpg", texture => {
      const geometry = new THREE.BoxGeometry(4, 0.2, 4);
      const material = new THREE.MeshStandardMaterial({
        map: texture,
        flatShading: true,
      });
      const startLocation = new THREE.Mesh(geometry, material);
      startLocation.position.set(0, 0.1, 0);
      startLocation.castShadow = true;
      startLocation.receiveShadow = true;
      startLocation.layers.set(1);
      startLocation.name = "StartLocation";

      // for Draggable Tree
      startLocation.key = startLocation.uuid;
      startLocation.title = startLocation.name + "(" + startLocation.uuid.substring(0, 3) + ")";
      startLocation.visible = true;

      // startLocation.userData.isKinematic = true;
      startLocation.userData.canCollide = true;
      startLocation.userData.friction = 1;
      startLocation.userData.mass = 0;
      startLocation.userData.type = "mesh";

      callback(startLocation);
    });
  }

  static createSpawnPoint(context, url, callback) {
    context.GLTFLoader.load(
      url,
      obj => {
        const spawnPoint = obj.scene;
        spawnPoint.layers.set(1);
        spawnPoint.name = "StartLocation";

        // for Draggable Tree
        spawnPoint.key = spawnPoint.uuid;
        spawnPoint.title = spawnPoint.name + "(" + spawnPoint.uuid.substring(0, 3) + ")";
        spawnPoint.visible = true;

        // spawnPoint.userData.isKinematic = true;
        spawnPoint.userData.canCollide = true;
        spawnPoint.userData.friction = 10;
        spawnPoint.userData.mass = 0;
        spawnPoint.userData.type = "mesh";

        callback(spawnPoint);
      },
      undefined,
      err => {
        console.error(err);
      },
    );
  }
}
export default StartLocation;
